import Immutable from 'immutable';
import * as app from 'actions/app';
import * as survey from 'actions/chat/interactiveSurvey';
import * as chat from 'actions/chat/';
import { MESSAGE_FROM, MESSAGE_TYPE, systemMessage, surveyAdditionalDataMessage } from './message';

var interactionSurveyFailed = false;

export const ADDITIONAL_DATA_TYPE = {
  textbox: 'TEXTBOX',
  textarea: 'TEXTAREA',
  listvalue: 'LISTVALUE',
};

export const sortAdditionalDataList = (x, y) => {
  if (x.order > y.order) {
    return 1;
  } else if (x.order < y.order) {
    return -1;
  } else {
    return 0;
  }
};

export const interactiveSurveyMessagesSubReducer = (mainState, action) => {
  switch (action.type) {
    case chat.ENDED:
      return mainState.clientConfiguration.interactiveSurveyEnabled
        && !mainState.ended && !interactionSurveyFailed
          ? mainState.messages.add(systemMessage({
            content: action.surveyTextHeader,
            type: MESSAGE_TYPE.interactiveSurvey.ask,
            bsStyle: 'primary',
          })) : mainState.messages;
    case survey.WILL_ANSWER:
      return mainState.messages.add(systemMessage({
        from: MESSAGE_FROM.client,
        name: mainState.client.userRenderHeader,
        content: mainState.clientConfiguration.interactiveSurvey.willAnswerLabel,
        bsStyle: 'success',
      })).add(surveyAdditionalDataMessage(action.nextAdditionalData));
    case survey.WONT_ANSWER:
      return mainState.messages.add(systemMessage({
        from: MESSAGE_FROM.client,
        name: mainState.client.userRenderHeader,
        content: mainState.clientConfiguration.interactiveSurvey.wontAnswerLabel,
        bsStyle: 'danger',
      }));
    case survey.ANSWER_ADDITIONAL_DATA:
      let messages = mainState.messages.add(systemMessage({
        from: MESSAGE_FROM.client,
        name: mainState.client.userRenderHeader,
        content: action.textualAnswer,
      }));

      if (action.nextAdditionalData) {
        return messages.add(surveyAdditionalDataMessage(action.nextAdditionalData));
      }
      return messages;
    case survey.SUBMIT:
      return mainState.messages.add(systemMessage({
        content: action.surveySuccessfullySavedMessage,
        type: MESSAGE_TYPE.interactiveSurvey.end,
        bsStyle: 'primary',
      })).add(systemMessage({
        content: action.surveyTextFooter,
        type: MESSAGE_TYPE.interactiveSurvey.end,
        bsStyle: 'primary',
      }));
    case survey.SUBMIT_FAIL:
      return mainState.messages.add(systemMessage({
        content: action.errorSavingSurveyMessage,
        type: MESSAGE_TYPE.interactiveSurvey.end,
        bsStyle: 'danger',
      }));
    default:
      return mainState.messages;
  }
};

export const initialState = {
  loading: false,
  error: undefined,
  surveyInformation: undefined,
  willAnswer: undefined,
  currentAdditionalDataIndex: undefined,
  ended: false,
  answers: Immutable.Map(),
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case survey.GET_INFORMATION_REQUEST:
      return { ...state, loading: true, error: undefined };
    case survey.GET_INFORMATION_FAIL:
      interactionSurveyFailed = true;
      return { ...state, loading: false, error: action.error };
    case survey.GET_INFORMATION:
      interactionSurveyFailed = false;
      return { ...state, loading: false, surveyInformation: action.surveyInformation };
    case survey.WILL_ANSWER:
      return { ...state, willAnswer: true, currentAdditionalDataIndex: 0 };
    case survey.WONT_ANSWER:
      return { ...state, willAnswer: false, ended: true };
    case survey.ANSWER_ADDITIONAL_DATA:
      return { ...state,
        answers: state.answers.set(action.additionalDataId, {
          additionalDataId: action.additionalDataId,
          answer: action.answer,
          index: action.index,
        }),
        currentAdditionalDataIndex: state.currentAdditionalDataIndex + 1,
      };
    case survey.SUBMIT:
      return { ...state, ended: true };
    case app.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./reducers/chat/interactiveSurvey.js